export default __webpack_public_path__ + "static/media/cover-process.b2233e1c.png";